import { LOCATION_ID_KEY } from '@/features/anonymousPurchasesStatistics/consts/dimensions';
import { createLocationFilter } from '@/filters/Location';

export const filterTypes = [
  createLocationFilter({
    key: LOCATION_ID_KEY,
    label: 'Название локации',
  }),
];
